
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f1FvE", function(module, exports) {

$parcel$export(module.exports, "isRTL", () => $af0725eda3e589bd$export$702d680b21cbd764);

const $af0725eda3e589bd$var$playIconUrl = new URL((parcelRequire("74kCa")));

const $af0725eda3e589bd$var$pauseIconUrl = new URL((parcelRequire("w2IHg")));

const $af0725eda3e589bd$var$muteIconUrl = new URL((parcelRequire("g0Lqb")));

const $af0725eda3e589bd$var$unmuteIconUrl = new URL((parcelRequire("i7iad")));
const $af0725eda3e589bd$var$prevSurahBtn = document.getElementById("prevSurahBtn");
const $af0725eda3e589bd$var$downloadBtn = document.getElementById("downloadBtn");
const $af0725eda3e589bd$var$loopBtn = document.getElementById("loopBtn");
const $af0725eda3e589bd$var$nextSurahBtn = document.getElementById("nextSurahBtn");
const $af0725eda3e589bd$var$audioPlayer = document.getElementById("audioPlayer");
const $af0725eda3e589bd$var$playBtn = document.getElementById("playBtn");
const $af0725eda3e589bd$var$playIcon = document.getElementById("playIcon");
const $af0725eda3e589bd$var$muteBtn = document.getElementById("muteBtn");
const $af0725eda3e589bd$var$muteBtnIcon = document.getElementById("muteBtnIcon");
const $af0725eda3e589bd$var$skipSecBtn = document.getElementById("skipSecBtn");
const $af0725eda3e589bd$var$prevSecBtn = document.getElementById("prevSecBtn");
const $af0725eda3e589bd$var$progressBar = document.getElementById("progressBar");
const $af0725eda3e589bd$var$surahCurrentTime = document.getElementById("surahCurrentTime");
const $af0725eda3e589bd$var$surahDuration = document.getElementById("surahDuration");
const $af0725eda3e589bd$var$surahSearchInput = document.getElementById("surahSearchInput");
const $af0725eda3e589bd$var$reciterSearchInput = document.getElementById("reciterSearchInput");
const $af0725eda3e589bd$export$702d680b21cbd764 = ()=>localStorage.getItem("language") === "ar";
function $af0725eda3e589bd$var$formatTime(seconds) {
    if (!isFinite(seconds) || seconds < 0) return "00:00";
    if (seconds >= 3600) {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor(seconds % 3600 / 60);
        const s = Math.floor(seconds % 60);
        return `${h.toString().padStart(2, "0")}:` + `${m.toString().padStart(2, "0")}:` + `${s.toString().padStart(2, "0")}`;
    }
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
}
function $af0725eda3e589bd$var$resetPlayer() {
    $af0725eda3e589bd$var$progressBar.value = 0;
    $af0725eda3e589bd$var$surahCurrentTime.innerText = "00:00";
    $af0725eda3e589bd$var$surahDuration.innerText = "00:00";
    $af0725eda3e589bd$var$playIcon.src = $af0725eda3e589bd$var$playIconUrl.href;
}
// -- Surah nav helpers --
function $af0725eda3e589bd$var$getCurrentSurahIdx() {
    return (window.allSurahs || []).findIndex((s)=>s.value === $af0725eda3e589bd$var$surahSearchInput.dataset.selectedValue);
}
function $af0725eda3e589bd$var$updateSurahNavBtns() {
    const idx = $af0725eda3e589bd$var$getCurrentSurahIdx();
    const total = (window.allSurahs || []).length;
    const hasSelection = idx !== -1;
    $af0725eda3e589bd$var$prevSurahBtn.disabled = !hasSelection || idx <= 0;
    $af0725eda3e589bd$var$nextSurahBtn.disabled = !hasSelection || idx >= total - 1;
}
// -- Play/Pause --
$af0725eda3e589bd$var$playBtn.addEventListener("click", ()=>{
    if ($af0725eda3e589bd$var$audioPlayer.paused) {
        $af0725eda3e589bd$var$audioPlayer.play();
        $af0725eda3e589bd$var$playIcon.src = $af0725eda3e589bd$var$pauseIconUrl.href;
    } else {
        $af0725eda3e589bd$var$audioPlayer.pause();
        $af0725eda3e589bd$var$playIcon.src = $af0725eda3e589bd$var$playIconUrl.href;
    }
});
// -- Mute/Unmute --
$af0725eda3e589bd$var$muteBtn.addEventListener("click", ()=>{
    $af0725eda3e589bd$var$audioPlayer.muted = !$af0725eda3e589bd$var$audioPlayer.muted;
    $af0725eda3e589bd$var$muteBtnIcon.src = $af0725eda3e589bd$var$audioPlayer.muted ? $af0725eda3e589bd$var$muteIconUrl.href : $af0725eda3e589bd$var$unmuteIconUrl.href;
});
$af0725eda3e589bd$var$audioPlayer.addEventListener("play", ()=>{
    $af0725eda3e589bd$var$playIcon.src = $af0725eda3e589bd$var$pauseIconUrl.href;
});
$af0725eda3e589bd$var$audioPlayer.addEventListener("pause", ()=>{
    $af0725eda3e589bd$var$playIcon.src = $af0725eda3e589bd$var$playIconUrl.href;
});
// -- Progress bar --
$af0725eda3e589bd$var$audioPlayer.addEventListener("timeupdate", ()=>{
    if (isFinite($af0725eda3e589bd$var$audioPlayer.duration)) {
        $af0725eda3e589bd$var$progressBar.value = $af0725eda3e589bd$var$audioPlayer.currentTime / $af0725eda3e589bd$var$audioPlayer.duration * 100;
        $af0725eda3e589bd$var$surahCurrentTime.innerText = $af0725eda3e589bd$var$formatTime($af0725eda3e589bd$var$audioPlayer.currentTime);
        $af0725eda3e589bd$var$surahDuration.innerText = $af0725eda3e589bd$var$formatTime($af0725eda3e589bd$var$audioPlayer.duration);
    }
});
$af0725eda3e589bd$var$audioPlayer.addEventListener("loadstart", ()=>{
    $af0725eda3e589bd$var$resetPlayer();
    $af0725eda3e589bd$var$downloadBtn.disabled = true;
});
$af0725eda3e589bd$var$audioPlayer.addEventListener("loadedmetadata", ()=>{
    $af0725eda3e589bd$var$surahDuration.innerText = $af0725eda3e589bd$var$formatTime($af0725eda3e589bd$var$audioPlayer.duration);
    $af0725eda3e589bd$var$progressBar.value = 0;
    $af0725eda3e589bd$var$downloadBtn.disabled = false;
});
$af0725eda3e589bd$var$progressBar.addEventListener("input", ()=>{
    if (isFinite($af0725eda3e589bd$var$audioPlayer.duration)) $af0725eda3e589bd$var$audioPlayer.currentTime = $af0725eda3e589bd$var$progressBar.value / 100 * $af0725eda3e589bd$var$audioPlayer.duration;
});
$af0725eda3e589bd$var$progressBar.addEventListener("click", (e)=>{
    if (isFinite($af0725eda3e589bd$var$audioPlayer.duration)) {
        const rect = $af0725eda3e589bd$var$progressBar.getBoundingClientRect();
        const clickPosition = (e.clientX - rect.left) / rect.width;
        $af0725eda3e589bd$var$audioPlayer.currentTime = Math.max(0, Math.min(clickPosition * $af0725eda3e589bd$var$audioPlayer.duration, $af0725eda3e589bd$var$audioPlayer.duration));
    }
});
// -- Skip / Rewind 10s (RTL-aware) --
$af0725eda3e589bd$var$skipSecBtn.addEventListener("click", ()=>{
    if ($af0725eda3e589bd$export$702d680b21cbd764()) $af0725eda3e589bd$var$audioPlayer.currentTime = Math.max(0, ($af0725eda3e589bd$var$audioPlayer.currentTime || 0) - 10);
    else $af0725eda3e589bd$var$audioPlayer.currentTime = Math.min(($af0725eda3e589bd$var$audioPlayer.currentTime || 0) + 10, $af0725eda3e589bd$var$audioPlayer.duration || Infinity);
});
$af0725eda3e589bd$var$prevSecBtn.addEventListener("click", ()=>{
    if ($af0725eda3e589bd$export$702d680b21cbd764()) $af0725eda3e589bd$var$audioPlayer.currentTime = Math.min(($af0725eda3e589bd$var$audioPlayer.currentTime || 0) + 10, $af0725eda3e589bd$var$audioPlayer.duration || Infinity);
    else $af0725eda3e589bd$var$audioPlayer.currentTime = Math.max(0, ($af0725eda3e589bd$var$audioPlayer.currentTime || 0) - 10);
});
// -- Download --
$af0725eda3e589bd$var$downloadBtn.addEventListener("click", async ()=>{
    const src = $af0725eda3e589bd$var$audioPlayer.src;
    if (!src || src === window.location.href) return;
    const surahName = $af0725eda3e589bd$var$surahSearchInput.value || "surah";
    const reciterName = $af0725eda3e589bd$var$reciterSearchInput.value || "reciter";
    const filename = `${reciterName}_${surahName}.mp3`;
    try {
        $af0725eda3e589bd$var$downloadBtn.disabled = true;
        $af0725eda3e589bd$var$downloadBtn.classList.add("player__btn--downloading");
        const response = await fetch(src);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    } catch (err) {
        console.error("Download failed:", err);
    } finally{
        $af0725eda3e589bd$var$downloadBtn.disabled = false;
        $af0725eda3e589bd$var$downloadBtn.classList.remove("player__btn--downloading");
    }
});
// -- Loop toggle --
$af0725eda3e589bd$var$loopBtn.addEventListener("click", ()=>{
    $af0725eda3e589bd$var$audioPlayer.loop = !$af0725eda3e589bd$var$audioPlayer.loop;
    $af0725eda3e589bd$var$loopBtn.setAttribute("aria-pressed", $af0725eda3e589bd$var$audioPlayer.loop);
    $af0725eda3e589bd$var$loopBtn.setAttribute("aria-label", $af0725eda3e589bd$var$audioPlayer.loop ? "Loop on" : "Loop off");
});
// -- Next/Prev surah --
$af0725eda3e589bd$var$nextSurahBtn.addEventListener("click", ()=>{
    const idx = $af0725eda3e589bd$var$getCurrentSurahIdx();
    const surahs = window.allSurahs || [];
    if (idx !== -1 && idx < surahs.length - 1) window.selectSurah(surahs[idx + 1]);
});
$af0725eda3e589bd$var$prevSurahBtn.addEventListener("click", ()=>{
    const idx = $af0725eda3e589bd$var$getCurrentSurahIdx();
    const surahs = window.allSurahs || [];
    if (idx > 0) window.selectSurah(surahs[idx - 1]);
});
// -- Auto-advance on end --
$af0725eda3e589bd$var$audioPlayer.addEventListener("ended", ()=>{
    if (!$af0725eda3e589bd$var$audioPlayer.loop) {
        const idx = $af0725eda3e589bd$var$getCurrentSurahIdx();
        const surahs = window.allSurahs || [];
        if (idx !== -1 && idx < surahs.length - 1) window.selectSurah(surahs[idx + 1]); // autoPlay defaults to true → next surah plays automatically
    }
    $af0725eda3e589bd$var$updateSurahNavBtns();
});
window.addEventListener("surahListUpdated", $af0725eda3e589bd$var$updateSurahNavBtns);

});
parcelRegister("74kCa", function(module, exports) {
module.exports = import.meta.resolve("kzMTo");

});

parcelRegister("w2IHg", function(module, exports) {
module.exports = import.meta.resolve("6rBPG");

});

parcelRegister("g0Lqb", function(module, exports) {
module.exports = import.meta.resolve("e9tr3");

});

parcelRegister("i7iad", function(module, exports) {
module.exports = import.meta.resolve("6RfJc");

});



parcelRequire("f1FvE");

//# sourceMappingURL=repo.a4a875c6.js.map
